import React, { useState } from "react";
import { Input, Dropdown, Badge, Avatar } from "antd";
import { useNavigate } from "react-router-dom";
import {
  MenuOutlined,
  SearchOutlined,
  CalendarOutlined,
  BellOutlined,
  UserOutlined,
  LogoutOutlined,
  SettingOutlined,
  ProfileOutlined,
  DownOutlined,
} from "@ant-design/icons";
import "./TopHeader.css";

function TopHeader({ onToggleSidebar }) {
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState("");

  // Get admin username from localStorage
  const username = localStorage.getItem("username") || "Admin";

  // Get current date
  const currentDate = new Date().toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  // ✅ Logout function
  const handleLogout = () => {
    localStorage.clear();
    navigate("/Admin_Login");
  };

  // ✅ Profile Dropdown Menu
  const profileMenu = {
    items: [
      {
        key: "1",
        icon: <ProfileOutlined />,
        label: "My Profile",
        onClick: () => navigate("/Admin_Panel"),
      },
      {
        key: "2",
        icon: <SettingOutlined />,
        label: "Settings",
        onClick: () => navigate("/settings-admin"),
      },
      {
        type: "divider",
      },
      {
        key: "3",
        icon: <LogoutOutlined />,
        label: "Logout",
        danger: true,
        onClick: handleLogout,
      },
    ],
  };

  // ✅ Notifications Dropdown
  const notificationsMenu = {
    items: [
      {
        key: "1",
        label: (
          <div className="notification-item">
            <div className="notification-icon success">✓</div>
            <div className="notification-content">
              <div className="notification-title">New User Registered</div>
              <div className="notification-time">2 min ago</div>
            </div>
          </div>
        ),
      },
      {
        key: "2",
        label: (
          <div className="notification-item">
            <div className="notification-icon warning">⚠</div>
            <div className="notification-content">
              <div className="notification-title">New Withdrawal Request</div>
              <div className="notification-time">10 min ago</div>
            </div>
          </div>
        ),
      },
      {
        key: "3",
        label: (
          <div className="notification-item">
            <div className="notification-icon info">💬</div>
            <div className="notification-content">
              <div className="notification-title">New Contact Enquiry</div>
              <div className="notification-time">1 hour ago</div>
            </div>
          </div>
        ),
      },
      {
        type: "divider",
      },
      {
        key: "4",
        label: (
          <div className="notification-view-all">View All Notifications</div>
        ),
      },
    ],
  };

  return (
    <header className="admin-top-header">
      {/* Left: Toggle Button + Page Title */}
      <div className="header-left">
        <button className="header-toggle-btn" onClick={onToggleSidebar}>
          <MenuOutlined />
        </button>
        <div className="header-page-title">
          <h1>Dashboard Overview</h1>   
        </div>
      </div>

      {/* Right: Search + Actions */}
      <div className="header-right">

        {/* Date Display */}
        <div className="header-date">
          <CalendarOutlined className="header-date-icon" />
          <span>{currentDate}</span>
        </div>

        {/* Notifications */}
        {/* <Dropdown
          menu={notificationsMenu}
          trigger={["click"]}
          placement="bottomRight"
          overlayClassName="notifications-dropdown"
        >
          <div className="header-notification">
            <Badge count={8} size="small">
              <BellOutlined className="header-bell-icon" />
            </Badge>
          </div>
        </Dropdown> */}

        {/* Profile Dropdown */}
        <Dropdown
          menu={profileMenu}
          trigger={["click"]}
          placement="bottomRight"
          overlayClassName="profile-dropdown"
        >
          <div className="header-profile">
            <Avatar
              size={40}
              icon={<UserOutlined />}
              className="header-avatar"
            />
            <div className="header-profile-info">
              <div className="header-username">{username}</div>
              <div className="header-role">Super Administrator</div>
            </div>
            <DownOutlined className="header-dropdown-icon" />
          </div>
        </Dropdown>
      </div>
    </header>
  );
}

export default TopHeader;